<template>
  <div class="page">
      Disclaimer
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
  },
  data() {
      return {
      }
  },
  computed: {
      ...mapGetters([
      ]),
  },
  methods: {
  },
  created() {
  }
}
</script>

<style scoped>
</style>
